import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './Style/SubjectTopics.css';
import PdfFiles from "../AllData/PdfFiles";
import StudyOption from "../AllData/HomeData";
import TopNavbar from "../home/TopNavbar";
import TopHeader from "../home/TopHeader";
import PaidItems from "../AllData/PaidItems";


function AllSubjectTopics({ subject, type }) {
  const allPdfs = PdfFiles;
  const [pdfs, setPdfs] = useState([]);
  const [bookmarkedPdfs, setBookmarkedPdfs] = useState([]);
  const [dounloadPdfs, setDounloadPdfs] = useState([]);
  const studyOptions = StudyOption;
  const matchingItem = studyOptions?.find(item => item.id === type);
  const iconName = matchingItem ? matchingItem.symbol : '📝';

  // Check payment
  const isPayment = localStorage.getItem('userPayment');

  const paidItems = PaidItems;
  const isPaid = paidItems.includes(type);

  let demoTopics = [];

  if (subject == "physics") {
    if (type == "ncertshortnote") {
      demoTopics = ["CP02"];
    } else if (type == "formula") {
      demoTopics = ["CP01"];
    } else if (type == "mindmap") {
      demoTopics = ["CP03"];
    } else if (type == "topernote") {
      demoTopics = ["CP02"];
    } else if (type == "flashcard") {
      demoTopics = ["CP02"];
    }
  } else if (subject == "chemistry") {
    if (type == "ncertshortnote") {
      demoTopics = ["CC01"];
    } else if (type == "formula") {
      demoTopics = ["CC02"];
    } else if (type == "mindmap") {
      demoTopics = ["CC01"];
    } else if (type == "topernote") {
      demoTopics = ["CC01"];
    } else if (type == "flashcard") {
      demoTopics = ["CC02"];
    }
  } else {
    if (type == "ncertshortnote") {
      demoTopics = ["CB01"];
    } else if (type == "formula") {
      demoTopics = ["CB03"];
    } else if (type == "mindmap") {
      demoTopics = ["CB04"];
    } else if (type == "topernote") {
      demoTopics = ["CB04"];
    } else if (type == "flashcard") {
      demoTopics = ["CB01"];
    }
  }

  // demoTopics = ["CP01", "CP02", "CP04", "CP06", "CP10", "CP15", "CC01", "CC02", "CC04", "CC06", "CC10", "CC15", "CB01", "CB02", "CB04", "CB06", "CB10", "CB15"];
  const isDemo = (topic) => {
    return demoTopics.includes(topic);
  }





  useEffect(() => {
    const fetchData = () => {
      try {
        const filteredPdfs = allPdfs.filter(pdf =>
          pdf.subject === subject && pdf.type === type
        );
        setPdfs(filteredPdfs);

        const storedBookmarks = localStorage.getItem('pdfBookmarks');
        if (storedBookmarks) {
          const bookmarksData = JSON.parse(storedBookmarks);
          // Removed userId filtering logic here
          setBookmarkedPdfs(bookmarksData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [allPdfs, subject, type]);

  useEffect(() => {
    const storedDounloadPdfs = JSON.parse(localStorage.getItem('savePdfIdInLocalStorage')) || [];
    setDounloadPdfs(storedDounloadPdfs);
  }, []);

  const toggleBookmark = (pdf) => {
    const isBookmarked = bookmarkedPdfs.some(
      bookmark => bookmark.pdfId === pdf.id
    );

    const storedBookmarks = localStorage.getItem('pdfBookmarks');
    let allBookmarks = storedBookmarks ? JSON.parse(storedBookmarks) : [];

    if (isBookmarked) {
      // Remove bookmark based only on pdfId
      const updatedBookmarks = allBookmarks.filter(
        bookmark => bookmark.pdfId !== pdf.id
      );
      localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
      setBookmarkedPdfs(updatedBookmarks);
    } else {
      // Add bookmark without userId
      const newBookmark = {
        pdfId: pdf.id,
        subject: pdf.subject,
        pdfData: pdf,
        timestamp: new Date().toISOString()
      };

      const updatedBookmarks = [...allBookmarks, newBookmark];
      localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
      setBookmarkedPdfs(updatedBookmarks);
    }
  };


  return (
    <div className="subject-topics-page">
      <TopNavbar name={subject.charAt(0).toUpperCase() + subject.slice(1)} />
      <TopHeader name={subject.charAt(0).toUpperCase() + subject.slice(1)} />

      <div className="subject-categories">

        {pdfs.map((pdf) => {
          const isBookmarked = bookmarkedPdfs.some(
            bookmark => bookmark.pdfId === pdf.id
          );
          const isPdfDounloaded = dounloadPdfs.some(
            dounloadedpdf => dounloadedpdf === pdf.id
          );

          return (
            <>


              {isPayment || !isPaid || isDemo(pdf.topic) ? (<>

                <div className={`topic-card ${isBookmarked ? 'bookmarked' : ''}`} key={pdf.id}>

                  {isPdfDounloaded ? (
                    <div className="link">
                      <Link to={`/pdfviewer/${pdf.id}`} className="pdf-link" >
                        <p> {iconName} {pdf.name.length > 31 ? `${pdf.name.substring(0, 28)}...` : pdf.name} </p>
                        <p style={{ background: "blue", color: "white", padding: "4px", paddingLeft: "6px", paddingRight: "6px", borderRadius: "5px" }}>Open</p>
                      </Link>
                      <hr style={{ margin: "3px", }} className="hrline"></hr>
                      <p style={{ fontSize: "10px", color: "green" }}>Downloaded</p>
                      <div className="bookmark-icon" onClick={() => toggleBookmark(pdf)} title={isBookmarked ? "Remove bookmark" : "Add bookmark"}  >
                        {isBookmarked ? <p className="bookmarked-text">Saved</p> : <p className="bookmark-text">Save</p>}
                        {isBookmarked ? '★' : '☆'}
                      </div>
                    </div>

                  ) : (
                    <div className="link">
                      <Link to={`/pdfviewer/${pdf.id}`} className="pdf-link" >
                        <p> {iconName} {pdf.name.length > 31 ? `${pdf.name.substring(0, 28)}...` : pdf.name} </p>
                        <p style={{ background: "blue", color: "white", padding: "4px", paddingLeft: "6px", paddingRight: "6px", borderRadius: "5px" }}>Open</p>
                     </Link>
                      <hr style={{ margin: "3px", }} className="hrline"></hr>

                      <p style={{ fontSize: "10px", color: "#ff847b" }}>Not download</p>
                      <div className="bookmark-icon" onClick={() => toggleBookmark(pdf)} title={isBookmarked ? "Remove bookmark" : "Add bookmark"}  >
                        {isBookmarked ? <p className="bookmarked-text">Saved</p> : <p className="bookmark-text">Save</p>}
                        {isBookmarked ? '★' : '☆'}
                      </div>
                    </div>

                  )}
                  {(isPayment || !isPaid) ? (<></>) : (<> <p className="demo-highlight-text view-demo-text"  >View demo</p></>)}
                </div>

              </>) : (<>

                <div className={`topic-card ${isBookmarked ? 'bookmarked' : ''}`} key={pdf.id}>

                  {isPdfDounloaded ? (
                    <div className="link">
                      <Link to="/premium-paywall" className="pdf-link" >
                        <p> {iconName} {pdf.name.length > 31 ? `${pdf.name.substring(0, 28)}...` : pdf.name} </p>
                        <p style={{ background: "blue", color: "white", padding: "4px", paddingLeft: "6px", paddingRight: "6px", borderRadius: "5px" }}>Open</p>
                        <p className="unlock-text">🔒</p>
                      </Link>
                      <hr style={{ margin: "3px", }} className="hrline"></hr>
                      <p style={{ fontSize: "10px", color: "green" }}>Downloaded</p>

                      <div className="bookmark-icon" onClick={() => toggleBookmark(pdf)} title={isBookmarked ? "Remove bookmark" : "Add bookmark"}  >
                        {isBookmarked ? <p className="bookmarked-text">Saved</p> : <p className="bookmark-text">Save</p>}
                        {isBookmarked ? '★' : '☆'}
                      </div>
                    </div>

                  ) : (
                    <div className="link">
                      <Link to="/premium-paywall" className="pdf-link" >
                        <p> {iconName} {pdf.name.length > 31 ? `${pdf.name.substring(0, 28)}...` : pdf.name} </p>
                        <p style={{ background: "blue", color: "white", padding: "4px", paddingLeft: "6px", paddingRight: "6px", borderRadius: "5px" }}>Open</p>
                        <p className="unlock-text">🔒</p>
                      </Link>
                      <hr style={{ margin: "3px", }} className="hrline"></hr>
                      <p style={{ fontSize: "10px", color: "#ff847b" }}>Not download</p>

                      <div className="bookmark-icon" onClick={() => toggleBookmark(pdf)} title={isBookmarked ? "Remove bookmark" : "Add bookmark"}  >
                        {isBookmarked ? <p className="bookmarked-text">Saved</p> : <p className="bookmark-text">Save</p>}
                        {isBookmarked ? '★' : '☆'}
                      </div>
                    </div>
                  )}
                </div>
              </>)}
            </>
          );
        })}

      </div>
    </div >
  );
}

export default AllSubjectTopics;